<section class="app-dialog nueva-version-dialog" [attr.aria-busy]="cargando || guardando">
  <header class="app-dialog__header">
    <div class="app-dialog__heading">
      <div>
        <p class="app-dialog__eyebrow">Gestión de Proyectos</p>
        <h2 [id]="idTitulo">{{ titulo }}</h2>
        <p *ngIf="subtitulo">{{ subtitulo }}</p>
      </div>
    </div>
    <button type="button" class="app-dialog__close app-dialog__close--icono" aria-label="Cerrar" title="Cerrar"
            [disabled]="guardando" (click)="cancelar()">
      <span class="material-icons" aria-hidden="true">close</span>
    </button>
  </header>

  <div mat-dialog-content class="app-dialog__content nueva-version-dialog__contenido">
    <output class="nueva-version-dialog__estado" *ngIf="cargando">
      <span class="material-icons" aria-hidden="true">hourglass_top</span>
      Leyendo la etapa…
    </output>

    <div class="nueva-version-dialog__aviso is-error" role="alert" *ngIf="!cargando && errorCarga">
      <strong>{{ esEdicion ? "No se puede editar la versión." : "No se puede crear la versión." }}</strong>
      <p>{{ errorCarga }}</p>
      <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="cargar()">
        Volver a intentar
      </button>
    </div>

    <div class="nueva-version-dialog__rejilla" *ngIf="etapa && !cargando">
      <aside class="nueva-version-dialog__resumen" aria-label="Resumen de la etapa">
        <section class="nueva-version-dialog__tarjeta">
          <span class="nueva-version-dialog__etiqueta">Etapa</span>
          <strong class="nueva-version-dialog__valor">{{ etapa.nombre || "Sin nombre" }}</strong>
          <span class="nueva-version-dialog__sub">{{ fechas }}</span>
        </section>

        <section class="nueva-version-dialog__tarjeta">
          <div class="nueva-version-dialog__tarjeta-cabeza">
            <span class="nueva-version-dialog__etiqueta">Versiones de la etapa</span>
            <span class="nueva-version-dialog__cuenta">{{ filas.length }}</span>
          </div>
          <p class="nueva-version-dialog__sub nueva-version-dialog__vacio" *ngIf="!filas.length">
            Todavía no tiene versiones: esta será la primera.
          </p>
          <ul class="nueva-version-dialog__versiones" *ngIf="filas.length">
            <li *ngFor="let fila of filas; trackBy: trackFila" [class.is-edicion]="fila.enEdicion">
              <div class="nueva-version-dialog__version">
                <strong>{{ fila.nombre }}</strong>
                <span class="table-page__status-badge nueva-version-dialog__chip" [ngClass]="fila.chip.clase">
                  <span class="material-icons" aria-hidden="true">{{ fila.chip.icono }}</span>{{ fila.chip.texto }}
                </span>
              </div>
              <span class="nueva-version-dialog__sub">{{ fila.linea }}</span>
              <span class="nueva-version-dialog__en-edicion" *ngIf="fila.enEdicion">En edición</span>
            </li>
          </ul>
        </section>

        <section class="nueva-version-dialog__tarjeta" *ngIf="!esEdicion">
          <span class="nueva-version-dialog__etiqueta">Incidencias abiertas</span>
          <strong class="nueva-version-dialog__valor">{{ etapa.indicadores?.abiertas ?? 0 }}</strong>
          <span class="nueva-version-dialog__sub" *ngFor="let linea of lineasAbiertas">{{ linea }}</span>
        </section>
      </aside>

      <section class="nueva-version-dialog__datos" aria-labelledby="nueva-version-datos">
        <h3 id="nueva-version-datos" class="nueva-version-dialog__titulo">
          <span class="material-icons" aria-hidden="true">layers</span>
          Datos de la versión
        </h3>

        <output class="nueva-version-dialog__aviso" *ngIf="motivo">
          <strong>{{ esEdicion ? "No puedes editar esta versión." : "No puedes crear versiones en esta etapa." }}</strong>
          <p>{{ motivo }}</p>
        </output>

        <form class="nueva-version-dialog__campos" [formGroup]="formulario" autocomplete="off">
          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
            <mat-label>Nombre de versión</mat-label>
            <input matInput [id]="idNombre" formControlName="nombre" required [maxlength]="largoNombre" (input)="cambio()" />
            <mat-hint>{{ esEdicion ? "Debe ser único en la etapa" : "Sugerido: V + consecutivo + fecha de hoy" }}</mat-hint>
            <mat-hint align="end">{{ largo("nombre") }}/{{ largoNombre }}</mat-hint>
            <mat-error *ngIf="error('nombre', 'required')">Escribe el nombre de la versión.</mat-error>
            <mat-error *ngIf="error('nombre', 'repetido')">Ya hay una versión con ese nombre en la etapa.</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
            <mat-label>Ambiente</mat-label>
            <mat-select formControlName="ambiente" required (selectionChange)="cambioAmbiente()">
              <mat-option *ngFor="let ambiente of ambientes" [value]="ambiente">{{ ambiente }}</mat-option>
            </mat-select>
            <mat-hint>{{ esEdicion ? "No se cambia después de crearla." : "PRODUCTIVO pide la versión QA de origen." }}</mat-hint>
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__field nueva-version-dialog__completo"
                          subscriptSizing="dynamic" *ngIf="esProductivo && !esEdicion">
            <mat-label>Versión QA de origen</mat-label>
            <mat-select formControlName="origen" required (selectionChange)="cambio()">
              <mat-option *ngFor="let origen of origenesQA" [value]="origen.id">{{ origen.nombre }}</mat-option>
            </mat-select>
            <mat-hint *ngIf="origenesQA.length">Una versión QA de esta etapa que todavía no sale a productivo.</mat-hint>
            <mat-hint *ngIf="!origenesQA.length">La etapa no tiene versiones QA disponibles: crea primero la versión QA.</mat-hint>
            <mat-error *ngIf="error('origen', 'required')">Elige la versión QA de la que sale.</mat-error>
            <mat-error *ngIf="error('origen', 'noDisponible')">Esa versión ya no puede ser origen: elige otra.</mat-error>
          </mat-form-field>

          <!-- La etiqueta que se ve es mat-label; la que leen los lectores de pantalla es la <label for> oculta
               (mat-label va con aria-hidden para que no se lea dos veces). -->
          <mat-form-field appearance="outline" class="table-page__field nueva-version-dialog__completo" subscriptSizing="dynamic">
            <mat-label aria-hidden="true">Ruta de versión</mat-label>
            <label class="cdk-visually-hidden" for="nueva-version-ruta">Ruta de versión</label>
            <input matInput id="nueva-version-ruta" formControlName="ruta" [maxlength]="largoRuta" placeholder="[Ruta del servidor]"
                   (input)="cambio()" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__field nueva-version-dialog__completo" subscriptSizing="dynamic">
            <mat-label aria-hidden="true">Descripción</mat-label>
            <label class="cdk-visually-hidden" for="nueva-version-detalle">Descripción</label>
            <textarea matInput id="nueva-version-detalle" rows="4" formControlName="detalle" [maxlength]="largoDetalle"
                      placeholder="Cambios que incluye esta versión" (input)="cambio()"></textarea>
            <mat-hint align="end">{{ largo("detalle") }}/{{ largoDetalle }}</mat-hint>
          </mat-form-field>
        </form>

        <!-- T3b: las resoluciones que esperan versión (plan §1.3 y D3). -->
        <section class="nueva-version-dialog__entregas" aria-labelledby="nueva-version-entregas" *ngIf="muestraEntregas && !esEdicion">
          <h3 id="nueva-version-entregas" class="nueva-version-dialog__titulo">
            <span class="material-icons" aria-hidden="true">assignment_turned_in</span>
            {{ tituloEntregas }}
          </h3>
          <p class="nueva-version-dialog__sub" *ngIf="pendientes.length">
            Marcadas como resueltas en {{ etapa.nombre || "la etapa" }} y pendientes de versión.
          </p>
          <p class="nueva-version-dialog__sub" *ngIf="!pendientes.length">Ninguna resolución espera versión en esta etapa.</p>
          <ul class="nueva-version-dialog__pendientes" *ngIf="pendientes.length">
            <li *ngFor="let pendiente of pendientes; trackBy: trackPendiente">
              <div class="nueva-version-dialog__pendiente">
                <strong>{{ pendiente.titulo }}</strong>
                <span class="nueva-version-dialog__sub">{{ pendiente.linea }}</span>
              </div>
              <span class="table-page__status-badge is-pending nueva-version-dialog__chip">
                <span class="material-icons" aria-hidden="true">schedule</span>Pendiente de versión
              </span>
            </li>
          </ul>
        </section>

        <div class="app-aviso-info nueva-version-dialog__info" *ngIf="esEdicion && lineaCreacion">
          <span class="material-icons" aria-hidden="true">history</span>
          <p>{{ lineaCreacion }}</p>
        </div>

        <div class="app-aviso-info nueva-version-dialog__info" *ngIf="!esEdicion && (etapa.vigente?.nombre || avisoEntregas)">
          <span class="material-icons" aria-hidden="true">info</span>
          <p>
            <ng-container *ngIf="etapa.vigente?.nombre">Al guardar, <strong>{{ etapa.vigente?.nombre }}</strong> pasará a Cerrada.</ng-container>
            {{ avisoEntregas }}
          </p>
        </div>

        <div class="nueva-version-dialog__aviso" role="alert" *ngIf="conflicto">
          <strong>{{ esEdicion ? "La versión cambió mientras la editabas." : "Las versiones de la etapa cambiaron." }}</strong>
          <p>{{ conflicto }}</p>
        </div>

        <p class="nueva-version-dialog__mensaje" role="alert" *ngIf="mensaje">{{ mensaje }}</p>
      </section>
    </div>
  </div>

  <footer mat-dialog-actions class="app-dialog__footer nueva-version-dialog__pie">
    <span class="nueva-version-dialog__obligatorios">* Campos obligatorios</span>
    <button type="button" class="nueva-version-dialog__limpiar" *ngIf="!esEdicion" [disabled]="!editable" (click)="limpiar()">Limpiar</button>
    <button type="button" class="app-form-btn app-form-btn--secondary" *ngIf="esEdicion" [disabled]="guardando" (click)="cancelar()">
      Cancelar
    </button>
    <button type="button" class="app-form-btn app-form-btn--primary nueva-version-dialog__guardar" [disabled]="!puedeGuardar"
            [attr.aria-busy]="guardando" (click)="guardar()">
      {{ textoGuardar }}
    </button>
  </footer>
</section>
